/**
 * Notification action types and their corresponding routes
 */
const NOTIFICATION_ACTIONS = {
    VIEW_SCHEDULER: {
        routeName: 'DiaryScheduler',
        buildParams: (data) => ({
            start_datetime: data.action_params?.start_datetime,
            end_datetime: data.action_params?.end_datetime,
        }),
    },
    // Future actions can be added here
    // VIEW_ORDER: { routeName: 'OrderView', ... }
};

/**
 * Build a route object from notification data
 * Supports route-name-based, action-based, and URL-based notifications
 *
 * @param {Object} notification - Notification object with data property
 * @returns {Object|null} Route object for router.push() or null if no route
 */
export function buildNotificationRoute(notification) {
    // Route-name-based routing (preferred format)
    if (notification.data.route) {
        const route = {
            name: notification.data.route,
            params: notification.data.route_params || {},
        };

        if (notification.data.route_query) {
            route.query = notification.data.route_query;
        }

        return route;
    }

    // Legacy action-based routing
    const action = notification.data.action;
    if (action && NOTIFICATION_ACTIONS[action]) {
        const config = NOTIFICATION_ACTIONS[action];
        return {
            name: config.routeName,
            query: config.buildParams(notification.data),
        };
    }

    // Fallback to legacy URL-based routing (OLD FORMAT)
    if (notification.data.url) {
        try {
            let url;
            // Handle both absolute URLs and relative paths
            if (notification.data.url.startsWith('http://') || notification.data.url.startsWith('https://')) {
                url = new URL(notification.data.url);
            } else {
                url = new URL(notification.data.url, window.location.origin);
            }

            const queryParams = {};
            url.searchParams.forEach((value, key) => {
                queryParams[key] = value;
            });

            return {
                path: url.pathname,
                query: queryParams,
            };
        } catch {
            // Fallback: manual parsing
            const urlParts = notification.data.url.split('?');
            const path = urlParts[0];
            const queryParams = {};

            if (urlParts[1]) {
                const params = new URLSearchParams(urlParts[1]);
                params.forEach((value, key) => {
                    queryParams[key] = value;
                });
            }

            return {
                path: path,
                query: queryParams,
            };
        }
    }

    return null;
}
